import script from "./ChaseView.vue?vue&type=script&setup=true&lang=js"
export * from "./ChaseView.vue?vue&type=script&setup=true&lang=js"

import "./ChaseView.vue?vue&type=style&index=0&id=47a2e410&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47a2e410"]])

export default __exports__